/**
 * Cart drawer upsell — Club Jagger Plus
 * Le mini sélecteur Mensuel/Annuel bascule entre deux boutons. L'ajout passe par
 * window.JPCart.setClubPlan (/cart/add.js {id, selling_plan}) — chemin vérifié 200
 * avec les selling plans Stripe ; le composant natif <xo-cart-add> n'appliquait pas
 * le forfait de vente Stripe à la variante. Délégation d'événements pour survivre
 * aux re-render du drawer.
 */
(function () {
  'use strict';
  if (window.__jpcUpsellInit) return;
  window.__jpcUpsellInit = true;

  function setPlan(card, plan) {
    var p = plan === 'monthly' ? 'monthly' : 'annual';
    card.querySelectorAll('[data-jpc-plan]').forEach(function (o) {
      var active = o.dataset.jpcPlan === p;
      o.classList.toggle('is-active', active);
      o.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-jpc-native]').forEach(function (block) {
      if (block.dataset.jpcNative === p) { block.removeAttribute('hidden'); }
      else { block.setAttribute('hidden', ''); }
    });
  }

  document.addEventListener('click', function (e) {
    // 1) Monthly/Annual toggle
    var opt = e.target.closest('[data-jpc-plan]');
    if (opt) {
      var card = opt.closest('[data-jpc-upsell]');
      if (card) setPlan(card, opt.dataset.jpcPlan);
      return;
    }
    // 2) Add to cart — verified JPCart path (/cart/add.js {id, selling_plan}).
    var add = e.target.closest('[data-jpc-add]');
    if (add && window.JPCart) {
      e.preventDefault();
      add.disabled = true;
      add.classList.add('jpc--loading');
      window.JPCart.setClubPlan(add.dataset.jpcVariant, add.dataset.jpcSellplan)
        .then(function () {
          // Sur la page panier (/cart) : recharger pour refléter l'ajout ; dans le drawer : refresh en place.
          if (document.querySelector('.xo-main-cart')) { window.location.reload(); return; }
          return (window.JPCart.refreshDrawerInPlace || window.JPCart.refreshAndOpenDrawer)();
        })
        .then(function () { add.disabled = false; add.classList.remove('jpc--loading'); })
        .catch(function (err) {
          console.error('[JPC upsell] add error:', err);
          add.disabled = false;
          add.classList.remove('jpc--loading');
          window.location.href = '/cart';
        });
    }
  });
})();
